<template>
  <v-card class="timeout-modal">
    <v-card-title
      class="timeout-modal__heading"
    >Your Session is about to expire, please extend it!</v-card-title>

    <div class="timeout-modal__content">
      <v-container>
        <v-alert
          v-if="isErrorAlertVisible"
          class="mt-0 mb-3"
          type="error"
          :value="true"
        >Unable to handle request, please try again.</v-alert>

        <countdown
          class="text-sm-center red--text display-1"
          :milliseconds="sessionTimeLeft"
        />
      </v-container>
    </div>

    <v-divider />

    <v-card-actions class="account-modal__actions">
      <v-btn
        color="light-blue darken-3"
        flat
        @click="onExtendButtonClick"
      >extend</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onLogoutButtonClick"
      >logout</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  // Services
  import apiClient from '@/services/AccountClient'

  // Components
  import Countdown from '@/components/ui/Countdown'

  export default {
    name: 'SessionTimeoutModal',
    components: {
      Countdown
    },
    inject: ['endCurrentUserSession'],
    data () {
      return {
        isErrorAlertVisible: false
      }
    },
    computed: {
      ...mapGetters('admin', ['sessionTimeLeft', 'sessionTimeout'])
    },
    methods: {
      ...mapActions('admin', ['setAdmin', 'resetSessionTimer']),
      ...mapActions('modal', ['closeModal']),
      onExtendButtonClick () {
        this.extendSession()
      },
      onLogoutButtonClick () {
        this.endSession()
      },
      extendSession () {
        this.setIsErrorAlertVisible(false)

        return apiClient.sendRequest('GET', 'api/admin/v1/ping')
          .then(() => this.resetSessionTimer())
          .catch(() => this.setIsErrorAlertVisible(true))
      },
      endSession () {
        this.setIsErrorAlertVisible(false)
        this.endCurrentUserSession()
      },
      setIsErrorAlertVisible (isErrorAlertVisible) {
        this.$set(this, 'isErrorAlertVisible', isErrorAlertVisible)
      }
    }
  }
</script>
